@if (mode === 'renderer') {
  <div
    class="container-dc-outer"
    [ngStyle]="{
      'margin-top.px': element.fields.marginTop,
      'margin-bottom.px': element.fields.marginBottom,
      'padding-top.px': element.fields.paddingTop,
      'padding-right.px': element.fields.paddingRight,
      'padding-bottom.px': element.fields.paddingBottom,
      'padding-left.px': element.fields.paddingLeft,
      'background-color': element.fields.backgroundColor
    }"
  >
    <div
      class="container-dc-inner"
      [class.container-dc-inner--edit]="edit"
      [ngStyle]="{
        '--max-width': (element.fields.maxWidth || 1200) + 'px',
        '--tablet-max-width': (element.fields.tabletMaxWidth || 960) + 'px',
        '--mobile-max-width': (element.fields.mobileMaxWidth || 540) + 'px'
      }"
    >
      @for (comp of element.fields.elements; track comp; let i = $index) {
        <div
          class="element-wrapper"
          (click)="edit ? onElementClick(comp, $event) : null"
          [class.active-element]="dynamicPageEditorHelperService.editElementInGrid === comp && edit"
        >
          @if (edit) {
            <div class="element-toolbar">
              <div class="element-toolbar-left">
                <span class="el-type-label">{{ dynamicPagesService.getComponentNameById(comp.id) }}</span>
              </div>
              <div class="element-toolbar-right">
                <button class="el-btn" (click)="moveUp(i); $event.stopPropagation()" title="Move up"><i class="fa-solid fa-arrow-up"></i></button>
                <button class="el-btn" (click)="moveDown(i); $event.stopPropagation()" title="Move down"><i class="fa-solid fa-arrow-down"></i></button>
                <button class="el-btn" (click)="copy(i); $event.stopPropagation()" title="Copy"><i class="fa-solid fa-copy"></i></button>
                <button class="el-btn el-btn--danger" (click)="deleteElement(i); $event.stopPropagation()" title="Delete"><i class="fa-solid fa-trash"></i></button>
              </div>
            </div>
          }
          <ng-container
            *ngComponentOutlet="
              dynamicPagesService.getComponentById(comp.id);
              inputs: { element: comp, mode: 'renderer', edit: edit }
            "
          ></ng-container>
        </div>
      }

      @if (edit) {
        <div
          class="dp-dropzone"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
        >
          <div class="dp-dropzone-hint">
            <i class="fa-solid fa-circle-plus"></i>
            <span>Drop element here</span>
          </div>
          @if (dynamicPageEditorHelperService.copy) {
            <button class="dp-paste-btn" (click)="paste()">
              <i class="fa-solid fa-paste"></i>
              <span>{{ 'Paste' | translate }}</span>
            </button>
          }
        </div>
      }
    </div>
  </div>
}

@if (mode === 'editor') {
  <div class="editor">
    <lib-gung-tabset #ngbTab="gungTabset" justify="fill">
      <lib-gung-tab id="content">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Content</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="properties-cp-container">
            <ng-container *ngIf="dynamicPageEditorHelperService.editElementInGrid; else noSelection">
              <div class="element-name-title">
                {{ dynamicPagesService.getComponentNameById(dynamicPageEditorHelperService.editElementInGrid.id) }}
              </div>
              <ng-container
                *ngComponentOutlet="
                  dynamicPagesService.getComponentById(dynamicPageEditorHelperService.editElementInGrid.id);
                  inputs: { element: dynamicPageEditorHelperService.editElementInGrid, mode: 'editor' }
                "
              ></ng-container>
            </ng-container>
            <ng-template #noSelection>
              <p>Select component in container to edit.</p>
            </ng-template>
          </div>
        </ng-template>
      </lib-gung-tab>
      <lib-gung-tab id="styles">
        <ng-template libGungTabTitle>
          <div class="tab-title">
            <span>Styles</span>
          </div>
        </ng-template>
        <ng-template libGungTabContent>
          <div class="row">
            <div class="col-12">
              <lib-gung-number-input
                [gungTranslate]="'MAX_WIDTH_DESKTOP_PX'"
                [(ngModel)]="element.fields.maxWidth"
              ></lib-gung-number-input>
            </div>
            <div class="col-12">
              <lib-gung-number-input
                [gungTranslate]="'MAX_WIDTH_TABLET_PX'"
                [(ngModel)]="element.fields.tabletMaxWidth"
              ></lib-gung-number-input>
            </div>
            <div class="col-12">
              <lib-gung-number-input
                [gungTranslate]="'MAX_WIDTH_MOBILE_PX'"
                [(ngModel)]="element.fields.mobileMaxWidth"
              ></lib-gung-number-input>
            </div>
            <div class="col-12">
              <lib-dynamic-page-element-margin-padding
                [(marginTop)]="element.fields.marginTop"
                [(marginRight)]="element.fields.marginRight"
                [(marginBottom)]="element.fields.marginBottom"
                [(marginLeft)]="element.fields.marginLeft"
                [(paddingTop)]="element.fields.paddingTop"
                [(paddingRight)]="element.fields.paddingRight"
                [(paddingBottom)]="element.fields.paddingBottom"
                [(paddingLeft)]="element.fields.paddingLeft"
              ></lib-dynamic-page-element-margin-padding>
            </div>
            <div class="col-12 mb-2">
              <div class="d-flex color-dp-input">
                <lib-gung-text-input
                  [gungTranslate]="'BACKGROUND_COLOR'"
                  [(ngModel)]="element.fields.backgroundColor"
                ></lib-gung-text-input>
                <input class="input-color" type="color" [(ngModel)]="element.fields.backgroundColor" />
              </div>
            </div>
          </div>
        </ng-template>
      </lib-gung-tab>
    </lib-gung-tabset>
  </div>
}

@if (mode === 'preview') {
  <div class="text-center container-preview">
    <i class="fa-solid fa-display-code"></i>
  </div>
}
